<template>
  <section id="skeletonSwiper">
     
      <div class="swiper-bg">
        <div class="swiper-container">
          <div class="swiper-wrapper">
          
        <Skeleton class="swiper-slide" v-for="i in 8" :key="i"></Skeleton>
            
          </div>
        </div>
       
      </div>
  </section>
</template>
<script>
import Swiper from "swiper/swiper-bundle.min";


export default {
  name: "skeletonSwiper",

  inject: ["mediaQueries"],
  props: {
    bgColor:{
      type:String,
      default:"linear-gradient(45deg,rgba(21, 190, 149, 0.55) 30%,rgba(241, 114, 172, 0.55) 55%)"
    },
  },
 
  mounted() {
    this.initSlider(false);
  },

  methods: {
    initSlider(kill = false) {
      this.initSwiper("SkeletonSSlider", kill, () => {
        if (this.slider) {
          this.slider.destroy();
        }
        this.slider = new Swiper("#skeletonSwiper .swiper-container", {
          spaceBetween: 1,
          centeredSlides: this.mediaQueries.mobileSize ? true : false,
          centeredSlidesBounds: this.mediaQueries.mobileSize ? true : false,
          loop: false,
          speed: 500,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
        
          breakpoints: {
            300: {
              slidesPerView: 1,
              spaceBetween: 15,
            },
            500: {
              slidesPerView: 2,
              spaceBetween: 10,
            },
            992: {
              slidesPerView: 4,
              spaceBetween: 10,
            },
            1200: {
              slidesPerView: 4.3,
              spaceBetween: 10,
            },
          },
        });
      });
    },
  },
};
</script>
<style scoped>
.Skeleton{
  height: 450px;
} 
#skeletonSwiper * {
  margin: 0;
  padding: 0;
}
#skeletonSwiper {
  margin-block: 2rem 6rem;
}
#skeletonSwiper .swiper-bg {
  padding: 11px 11px;
  background: rgb(21, 190, 149);
  background:v-bind(bgColor);
  border-radius: 40px;
  position: relative;
  margin-top: 2.5rem;
}
#skeletonSwiper .swiper-bg .swiper-container {
  padding: 1rem 0rem;
  
  margin-bottom: -3rem;
  margin-top: -3rem;
}

#skeletonSwiper .swiper-bg .next-btn {
  transform: translateY(-50%);
  position: absolute;
  top: 50%;
  left: 99%;
  padding: 10px;
  cursor: pointer;
}
#skeletonSwiper .swiper-bg .prev-btn {
  transform: translateY(-50%);
  position: absolute;
  top: 50%;
  right: 99%;
  padding: 10px;
  cursor: pointer;
}
#skeletonSwiper .swiper-slide {
  background-color: #ffffff;
  border-radius: 20px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
}
#skeletonSwiper .custom-line {
  width: 100%;
  height: 1px;
  border-radius: 25px;
  background-color: #cccccc;
  flex-grow: 1;
}
#skeletonSwiper a {
  color: #ffffff;
  border: 1px solid var(--color-main);
  background-color: var(--color-main) !important;
  border-radius: 25px;
  padding: 8px 35px;
}
@media screen and (max-width:600px) {
  #skeletonSwiper {
    margin-block: 2rem 4rem;
  }
  .Skeleton{
    height: 323px;
  }
}
</style>